import { createCategoryHandler } from "../category-dispatcher";
import { componentTools } from "./component-tools";
import { responsiveTools } from "./responsive-tools";
import { visibilityTools } from "./visibility-tools";

/**
 * Category handler for component mutation operations.
 * Consolidates component-tools, responsive-tools, and visibility-tools sync handlers
 * for adding, configuring, deleting, selecting, moving, cloning, reordering, swapping,
 * renaming components, managing responsive column layout, and visibility/editability.
 */
export const handleComponentCategory = createCategoryHandler({
  add: componentTools.sync!.ui_structure_add_components,
  configure: componentTools.sync!.ui_structure_configure_components,
  delete: componentTools.sync!.ui_structure_delete_component,
  select: componentTools.sync!.ui_structure_select_component,
  move: componentTools.sync!.ui_structure_move_component,
  clone: componentTools.sync!.ui_structure_clone_component,
  reorder: componentTools.sync!.ui_structure_reorder_component,
  swap: componentTools.sync!.ui_structure_swap_components,
  rename: componentTools.sync!.ui_structure_rename_component,
  set_responsive_columns: responsiveTools.sync!.ui_structure_set_responsive_columns,
  resize_column: responsiveTools.sync!.ui_structure_resize_column,
  get_visibility: visibilityTools.sync!.ui_component_get_visibility,
  set_visibility: visibilityTools.sync!.ui_component_set_visibility,
  get_editability: visibilityTools.sync!.ui_component_get_editability,
  set_editability: visibilityTools.sync!.ui_component_set_editability
});

// KOA-18136 — the managed-task-screen ownership guard used to wrap THIS category.
// It now runs in front of the whole executor (`McpToolExecutor.execute`), because
// wrapping one category only ever protected that category: `ui_action`,
// `ui_property` and `ui_bind` stayed open, and those are the ones whose damage to
// the decision buttons is carried forward rather than corrected. See
// `managed-task-screen-guard.ts`.
